import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth-store'

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { token } = useAuthStore()
  const location = useLocation()
  if (!token) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />
  }
  return <>{children}</>
}
